import Swiper, { Navigation, Scrollbar, Controller } from "swiper";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";

export default () => {
	new Swiper(".block.block--slider .slider", {
		modules: [Navigation, Scrollbar, Controller],
		direction: "horizontal",
		slidesPerView: "auto",
		allowTouchMove: true,
		spaceBetween: 16,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});

	new Swiper(".block.instagram .slider", {
		modules: [Navigation, Scrollbar, Controller],
		direction: "horizontal",
		slidesPerView: "auto",
		allowTouchMove: true,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		scrollbar: {
			el: ".swiper-scrollbar",
			draggable: true,
		},
	});
};
